export type CurrentMemberCommonDetails = {
    userId: string;
    name: string;
    email: string;
    joinedDate: number;
};

export type OrgOwner = CurrentMemberCommonDetails & {
    role: "owner";
};

export type OrgAdmin = CurrentMemberCommonDetails & {
    role: "admin";
    invitationAccepted: true;
};

export type OrgMember = CurrentMemberCommonDetails & {
    role: "member";
    invitationAccepted: true;
};
export type CurrentMember = OrgOwner | OrgAdmin | OrgMember;

export type PendingMember = {
    email: string;
    role: "member";
    invitationAccepted: false;
    invitationLink: string;
};

export type OrganizationMember = CurrentMember | PendingMember;

export const isPendingMember = (T: OrganizationMember): T is PendingMember => {
    return "invitationAccepted" in T && T.invitationAccepted === false;
};
export const isCurrentMember = (T: OrganizationMember): T is CurrentMember => {
    return !isPendingMember(T);
};

export const isAdmin = (T: CurrentMember): T is OrgAdmin => {
    return T.role === "admin";
};
export const isOwner = (T: CurrentMember): T is OrgOwner => {
    return T.role === "owner";
};
export const isMember = (T: CurrentMember): T is OrgMember => {
    return T.role === "member";
};
